import { render, staticRenderFns } from "./OrderDetailWarranty.vue?vue&type=template&id=6dac230a"
import script from "./OrderDetailWarranty.vue?vue&type=script&lang=js"
export * from "./OrderDetailWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports